import { render, staticRenderFns } from "./StudioBoard.vue?vue&type=template&id=134fdb35&scoped=true"
import script from "./StudioBoard.vue?vue&type=script&lang=js"
export * from "./StudioBoard.vue?vue&type=script&lang=js"
import style0 from "./StudioBoard.vue?vue&type=style&index=0&id=134fdb35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fdb35",
  null
  
)

export default component.exports